import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { PartnerService } from '@services/partner/partner.service';
import { Partner } from '@shared/models/partner.model';

export const partnersResolver: ResolveFn<Partner | null> = (route: ActivatedRouteSnapshot): Observable<Partner | null> => {
  const partnerService = inject(PartnerService);
  const router = inject(Router);
  const partnerFid = route.params.partnerFid;

  if (partnerFid) {
    return partnerService.getPartner(partnerFid).pipe(
      mergeMap((partner: Partner) => {
        if (partner) {
          return of(partner);
        } else {
          return of(null);
        }
      }),
      catchError(() => {
        router.navigate(['/404']);
        return of(null);
      })
    );
  }
  return of(null);
};
